// table 数据相关
import request from '@/api/request'

/*  
    serverUrl : 基础的 api 地址
    tableFilterData ： 过滤数据
        {
            require(
                status、searchword
            )
        }
    tablePageData ： 分页数据
*/
export function getListApi(serverUrl: string | undefined
    , tableFilterData: any
    , tablePageData: any, sid?: string, pid?: string) {
    let url = serverUrl + "/list" ;
    let data: any = {
        "status": tableFilterData.status,
        "searchprop": tableFilterData.searchProp,
        "searchword": tableFilterData.searchword,
        "current": tablePageData.current,
        "page": tablePageData.page,
        "start": tablePageData.start,
        "size": tablePageData.size,
        sid,
        pid,
    }

    if (tableFilterData) {
        if (tableFilterData.status != undefined) {
        data.status = tableFilterData.status;
        }

        if (tableFilterData.searchword != undefined) {
        data.searchword = tableFilterData.searchword;
        }

        if (tableFilterData.sid != undefined) {
            data.sid = tableFilterData.sid;
        }
        if (tableFilterData.pid != undefined) {
            data.pid = tableFilterData.pid;
        }
        if (tableFilterData.partyids != undefined) {
            data.partyids = tableFilterData.partyids;
        }
        if (tableFilterData.unitids != undefined) {
            data.unitids = tableFilterData.unitids;
        }
        if (tableFilterData.checkid != undefined) {
            data.checkid = tableFilterData.checkid;
        }
        if (tableFilterData.ccpid != undefined) {
            data.ccpid = tableFilterData.ccpid;
        }
        if (tableFilterData.rsid != undefined) {
            data.rsid = tableFilterData.rsid;
        }
        // datamap
        if (tableFilterData.dataMap) {
            let map = tableFilterData.dataMap;

            if(map instanceof Map){
                map.forEach((value: any, key: any) => {
                    data[key] = value;
                });
            }
            else {
                console.log("data map is not map!",typeof map)
            }


        }
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}



/*  
    serverUrl : 基础的 api 地址
    id : data id
*/
export function stopApi(serverUrl: string | undefined
    , id: string | undefined) {
    let url = serverUrl + "/stop";

    let data = {
        "id": id
    }


    return request({
        url: url,
        method: 'post',
        data
    })
}

/*  
    serverUrl : 基础的 api 地址
    id : data id
*/
export function startApi(serverUrl: string | undefined
    , id: string | undefined) {
    let url = serverUrl + "/start";

    let data = {
        "id": id
    }


    return request({
        url: url,
        method: 'post',
        data
    })
}

/*  
    serverUrl : 基础的 api 地址
    id : data id
*/
export function deleteApi(serverUrl: string | undefined
    , id: string | undefined) {
    let url = serverUrl + "/delete";

    let data = {
        "id": id
    }

    return request({
        url: url,
        method: 'post',
        data
    })
}